export class LazyLoadBlock {
  constructor () {
    const selector = '.js-lazy-load-block';

    lozad(selector, {
      load: function(block) {
        const url = block.getAttribute('data-url');

        if (!url) return;
          fetch(url)
            .then(response => response.json())
            .then(function(response) {
              const data = response;
              block.classList.remove('loading');

              if (data.status === 'error') {
                block.classList.add('error');
                block.innerHTML = '<div class="container">' + data.message + '</div>';
                console.warn(data);
              } else {
                block.innerHTML = data.message;
              }
            });
      }
    }).observe();
  }



}


